import CheckoutLogin from '@/components/checkout/login/CheckoutLogin';

export const LoginSection = () => <CheckoutLogin />;
